import { Component, Event, EventEmitter, Listen } from "@stencil/core";
import { getInquiryData } from "@stores/inquiry.store";
import { ProductAddedToInquiryEventDetails } from "../../../../../components/inquiry/bcp-add-to-inquiry-model";

@Component({
  tag: "f-inquiry-proxy",
  styleUrl: "f-inquiry-proxy.scss",
  shadow: false,
})
export class FInquiryProxy {
  @Event()
  productAddedToInquiry: EventEmitter<ProductAddedToInquiryEventDetails>;

  @Listen("onInquiryChange", { target: "window" })
  handleOrderChange(event: CustomEvent): void {
    if (event.detail && event.detail.data) {
      // setInquiryData(event.detail.data);
      this.productAddedToInquiry.emit();
    } else {
      getInquiryData().then(() => {
        this.productAddedToInquiry.emit();
      });
    }
  }
}
